import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import Workflow from '../Workflow';
import changeAirport from '../../js/airport/changeAirport';
import WorkflowAudit from '@/components/WorkflowAudit.vue';

@Component({
    components: {
        WorkflowAudit,
    },
    filters: {
        Date_MD(data: any) {
            return moment(data).format('MM-DD');
        },
        WeekDay(data: any) {
            moment.locale('zh-cn');
            return moment(data).format('dddd');
        },
        Date_mm(data: any) {
            return moment(data).format('YYYY-MM-DD HH:MM');
        },
        City(data: any) {
            return changeAirport.changeAirportCode(data).cityCName || '无';
        },
        AirPort(data: string) {
            return changeAirport.changeAirportCode(data).airportCName || '无';
        },
        AirLine(data: string) {
            return changeAirport.changeAirCompany(data) || '无';
        },
        ServiceLevel(data: string) {
            if (data === 'F') {
                return '头等舱';
            } else if (data === 'C') {
                return '商务舱';
            } else if (data === 'Y') {
                return '经济舱';
            }

        },
        DisCount(data: number) {
            return (data * 10).toFixed(1);
        },
    },
})
export default class AuditAirTicket extends Vue {
    private $api: any;
    private isLoading: boolean = false;
    private showDetails: boolean = false;   // 是否打开消费明细弹出层
    private WorkflowItemCode: any = '0034'; // 工作流审核时所需Code
    private workFlowData: any = []; // 工作流按钮权限
    private trip: any = {}; // 列表页获取的行程信息
    private vm: any = {}; // 获取的订票信息
    private OrderPrice: any = 0; // 除服务费之外的费用
    private ServicePay: any = 0; // 服务费
    private tripinfo: any = {}; // 出差信息

    private async created() {
        this.trip = JSON.parse(localStorage.getItem('tripInfo') || '');
        // 根据ID获取机票信息
        if (this.trip.Id) {
            this.getTripInfo();
            this.getWorkFlow();
        }
        this.getBussinessTripInfo();
    }

    // 获取出差信息
    private async getBussinessTripInfo() {
        this.$toast.loading({
            mask: true,
            message: '加载中...',
            duration: 0,
        });
        const params = {
            BusinessTripInfoId: this.trip.BusinessTripInfoId || '',
        };
        const result = await this.$api.httpGet('Membership/TripInfo/GetBusinessTripInfoById', params);
        if (result.Success) {
            if (result.Data) {
                this.tripinfo = result.Data;
            }
            this.$toast.clear();
            this.isLoading = true;
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }

    // 获取机票信息
    private async getTripInfo() {
        this.$toast.loading({
            mask: true,
            message: '加载中...',
            duration: 0,
        });
        const model = {
            id: this.trip.Id,
        };
        const result = await this.$api.httpGet('basic/Ticket/QueryTicketInfoById', model);
        if (result.Success) {
            if (result.Data) {
                this.ServicePay = result.Data.ServicePay;
                // 机票信息
                if (result.Data.NewTicket) {
                    this.vm = result.Data.NewTicket;
                    this.vm.cardType = changeAirport.changeCertificates(this.vm.cardType);
                    this.OrderPrice = this.vm.parPrice + this.vm.taxFee + this.vm.fuelFee;
                }
            }
            this.$toast.clear();
            this.isLoading = true;
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }

    // 获取工作流信息
    private getWorkFlow() {
        Workflow.GetRuntimeItem(this.WorkflowItemCode, this.trip.Id, (response: any) => {
            if (response.Success) {
                if (response.Data) {
                    this.workFlowData = response.Data;
                }
            } else {
                this.$dialog.alert({
                    title: '错误',
                    message: response.AllMessages,
                });
            }
        }, (error: any) => {
            this.$dialog.alert({
                message: error,
            });
        });
    }

    // 查看当日机票
    private showCurrentAir() {
        localStorage.setItem('AirTicketFor', 'auditAir');
        localStorage.setItem('AirTicketTrip', JSON.stringify(this.trip));
        localStorage.setItem('CurrentTripInfo', JSON.stringify(this.trip));
        this.$router.push('/airticket-booking');
    }


    /**
     * 运维需求-去掉前台发消息功能
     */
    // private async sendWechatMsg(msgModel: any) {
    //     const result = await this.$api.httpPost('Membership/TripBookTicket/SendTicketMessageAduit', msgModel);
    //     this.$toast.clear();
    //     this.isLoading = true;
    //     if (result.Success) {
    //         this.$dialog.alert({
    //             title: '审核成功!',
    //         }).then(() => {
    //             console.log('跳转');
    //             this.$router.push('/tripinfo-list');
    //         });
    //     } else {
    //         this.$dialog.alert({
    //             title: '发送消息',
    //             message: result.AllMessages,
    //         });
    //     }
    // }

    // 审核成功后事件（监听审核结果）
    private auditCallBack(item: any) {
        this.$toast.loading({
            mask: true,
            message: '加载中...',
            duration: 0,
        });
        // 发送微信消息
        const msgModel = {
            WorkFlowStatus: item,
            TicketId: this.trip.Id,
        };
        setTimeout(() => {
            // this.sendWechatMsg(msgModel);
            this.$toast.clear();
            // this.isLoading = true;
            this.$dialog.alert({
                title: '审核成功!',
            }).then(() => {
                this.$router.push('/tripinfo-list');
            });
        }, 4000);

    }
}
